import * as Storage from "../lib/Storage.ts";
import * as Html from "./Html.ts";
export {hasSeen,markSeen}

const FEATURES = {
  'filer.onboarding': {limit:new Date('2030-12-31')},
  'budget.markaspaid':{limit:new Date('2024-12-31')},
  birthdaySourceEditableEducational:{limit:new Date('2050-12-31')},
}

function hasSeen(key){
  if(Storage.sessionGet('logfromdeeplink')==='true'){
    return true;
  }
  let feature = FEATURES[key];
  if(!feature){
    console.log('No feature '+key);
    return true;
  }
  if(new Date()>feature.limit){
    return true;
  }
  return Storage.localGet("feature."+key)==='true';
}

function markSeen(key){
  Storage.localSet("feature."+key,'true');
}

Html.register({
  featureseen(key){
    markSeen(key)
  }
})